/* Perry Spices shopper features (Oct 10):
   heat meter + recipe links on product pages, heat pills on product cards,
   back-in-stock "notify me", sticky add to cart on phones, recently viewed. */
(function(){
  var D = window.PS_SHOP || { heat: {} };
  var isProduct = document.body.classList.contains('template-product');

  function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function el(tag, cls, html){ var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function money(cents){ return '$' + (cents / 100).toFixed(2); }
  function shortName(t){ return String(t || '').split('|')[0].replace(/^Perry Spices\s+/i, '').trim(); }
  function store(k, v){ try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch(e){ return null; } }

  /* ---------- heat pills on product cards ---------- */
  function heatPills(root){
    if (!D.heat) return;
    (root || document).querySelectorAll('.product-card-wrapper').forEach(function(card){
      if (card.dataset.psDone) return;
      var a = card.querySelector('a[href*="/products/"]'); if (!a) return;
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); if (!m) return;
      if (!D.more || D.full) card.dataset.psDone = '1';
      var st = D.stars && D.stars[m[1]];
      if (st && st[1] > 0 && !card.querySelector('.ps-stars')){
        var heads = card.querySelectorAll('.card__heading'); var head = heads[heads.length - 1];
        if (head){
          var pct = Math.max(0, Math.min(100, (Number(st[0]) / 5) * 100));
          var s = el('div', 'ps-stars', '<span class="ps-stars__bg" aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;<span class="ps-stars__fg" style="width:' + pct + '%">&#9733;&#9733;&#9733;&#9733;&#9733;</span></span>');
          s.setAttribute('aria-label', 'Rated ' + Number(st[0]).toFixed(1) + ' out of 5');
          head.after(s);
        }
      }
      var h = D.heat[m[1]]; if (!h || card.querySelector('.ps-heat-pill')) return;
      var media = card.querySelector('.card__inner') || card;
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      var pill = el('span', 'ps-heat-pill', '<span aria-hidden="true">&#127798;&#65039;</span> ' + String(h).replace('.0','') + '/5');
      pill.setAttribute('aria-label', 'Heat ' + h + ' out of 5');
      media.appendChild(pill);
    });
  }

  /* ---------- product page extras ---------- */
  function pdp(){
    var dataEl = document.getElementById('ps-pdp-data'); if (!dataEl) return;
    var P; try { P = JSON.parse(dataEl.textContent); } catch(e){ return; }
    var info = document.querySelector('.product__info-container');
    var tpl = document.getElementById('ps-pdp-extras');
    if (tpl && info){
      var frag = tpl.content.cloneNode(true);
      var heat = frag.querySelector('[data-ps-slot="heat"]');
      var cook = frag.querySelector('[data-ps-slot="recipes"]');
      var price = info.querySelector('.price-wrapper, [id^="price-"]');
      if (heat){ if (price && price.parentNode === info) price.after(heat); else info.prepend(heat); }
      var meta = info.querySelectorAll('.metafield-rich_text_field');
      if (cook){ if (meta.length) meta[meta.length - 1].after(cook); else if (heat) heat.after(cook); else info.appendChild(cook); }
    }

    /* recently viewed: remember this product */
    var rv = store('ps_rv') || [];
    rv = [P.handle].concat(rv.filter(function(h){ return h !== P.handle; })).slice(0, 12);
    store('ps_rv', rv);

    var form = document.querySelector('.product__info-container product-form form, product-form form');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var submit = form ? form.querySelector('[type="submit"], .product-form__submit') : null;
    function currentVariant(){
      var id = idInput ? parseInt(idInput.value, 10) : null;
      return P.variants.filter(function(v){ return v.id === id; })[0] || P.variants[0];
    }

    /* back in stock */
    var bis = null;
    if (form){
      bis = el('div', 'ps-bis', '<div class="ps-bis__label">Don’t miss the next batch</div><p class="ps-bis__text">Drop your email and we’ll let you know the second it’s back.</p><form class="ps-bis__form" novalidate><label class="visually-hidden" for="ps-bis-email">Email</label><input id="ps-bis-email" type="email" autocomplete="email" placeholder="Your email" required><button type="submit">Notify me</button></form><p class="ps-bis__msg" role="status" aria-live="polite"></p>');
      bis.hidden = true;
      (form.closest('product-form') || form).after(bis);
      bis.querySelector('form').addEventListener('submit', function(ev){
        ev.preventDefault();
        var input = bis.querySelector('input'), btn = bis.querySelector('button'), msg = bis.querySelector('.ps-bis__msg');
        var email = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ msg.textContent = 'Enter a valid email.'; input.focus(); return; }
        btn.disabled = true; msg.textContent = 'Saving…';
        var v = currentVariant();
        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(D.klaviyo), {
          method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } } } } })
        }).then(function(r){
          if (r.ok){
            fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(D.klaviyo), {
              method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
              body: JSON.stringify({ data: { type: 'profile', attributes: { email: email, properties: { 'Restock Product': shortName(P.title), 'Restock URL': P.url, 'Restock Image': P.image } } } })
            }).catch(function(){});
          }
          msg.textContent = r.ok ? 'You’re on the list. We’ll email you when it’s back.' : 'Something went wrong. Please try again.';
          if (r.ok) input.value = '';
          btn.disabled = false;
        }).catch(function(){ msg.textContent = 'Something went wrong. Please try again.'; btn.disabled = false; });
      });
    }

    /* sticky add to cart (phones) */
    var bar = null;
    if (submit){
      bar = el('div', 'ps-sticky', '<div class="ps-sticky__info"><span class="ps-sticky__name"></span><span class="ps-sticky__price"></span></div><button type="button" class="ps-sticky__btn">Add Flavor</button>');
      bar.querySelector('.ps-sticky__name').textContent = shortName(P.title);
      document.body.appendChild(bar);
      bar.querySelector('.ps-sticky__btn').addEventListener('click', function(){ if (!submit.disabled) submit.click(); });
      var onScreen = true;
      if ('IntersectionObserver' in window){
        new IntersectionObserver(function(es){ onScreen = es[0].isIntersecting || es[0].boundingClientRect.top > 0; sync(); }, { threshold: 0 }).observe(submit);
      }
    }
    function bottomOffset(){
      var off = 0;
      document.querySelectorAll('body > *').forEach(function(n){
        if (n === bar) return;
        var s = getComputedStyle(n);
        if ((s.position === 'fixed' || s.position === 'sticky') && s.display !== 'none' && parseFloat(s.bottom) <= 1){
          var r = n.getBoundingClientRect();
          if (r.width >= window.innerWidth * 0.9 && r.height < 120 && r.bottom >= window.innerHeight - 2) off = Math.max(off, r.height);
        }
      });
      return off;
    }
    function sync(){
      var v = currentVariant();
      if (bis) bis.hidden = !!v.available;
      if (bar){
        var p = document.querySelector('.product__info-container .price-item--sale, .product__info-container .price-item--regular');
        bar.querySelector('.ps-sticky__price').textContent = p ? p.textContent.trim() : '';
        var show = !onScreen && v.available && window.innerWidth < 750;
        bar.style.bottom = bottomOffset() + 'px';
        bar.classList.toggle('is-on', show);
        document.body.classList.toggle('ps-sticky-on', show);
        document.documentElement.style.setProperty('--ps-sticky-h', show ? (bar.offsetHeight + bottomOffset()) + 'px' : '0px');
      }
    }
    var last = idInput ? idInput.value : null;
    setInterval(function(){ if (idInput && idInput.value !== last){ last = idInput.value; sync(); } }, 400);
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------- recently viewed row ---------- */
  function recentlyViewed(){
    if (!isProduct && !document.body.classList.contains('template-collection')) return;
    var current = null;
    var dataEl = document.getElementById('ps-pdp-data');
    if (dataEl){ try { current = JSON.parse(dataEl.textContent).handle; } catch(e){} }
    var list = (store('ps_rv') || []).filter(function(h){ return h !== current; }).slice(0, 8);
    if (list.length < 1) return;
    var anchor = document.querySelector('.section-psf') || document.querySelector('footer');
    if (!anchor) return;
    var wrap = el('section', 'ps-rv', '<div class="ps-rv__inner"><div class="ps-rv__kicker">Pick up where you left off</div><h2 class="ps-rv__title">Recently viewed</h2><div class="ps-rv__track"></div></div>');
    var track = wrap.querySelector('.ps-rv__track');
    Promise.all(list.map(function(h){
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    })).then(function(items){
      items = items.filter(Boolean).slice(0, 6);
      if (!items.length) return;
      items.forEach(function(p){
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
        var a = el('a', 'ps-rv__card', (img ? '<span class="ps-rv__media"><img loading="lazy" src="' + esc(img) + '" alt="' + esc(p.title) + '" width="400" height="400"></span>' : '') + '<span class="ps-rv__name">' + esc(shortName(p.title)) + '</span><span class="ps-rv__price">' + money(p.price) + '</span>');
        a.href = p.url;
        track.appendChild(a);
      });
      anchor.parentNode.insertBefore(wrap, anchor);
    });
  }


  /* ---------- apparel page: filters, size tap-to-add, new badges, pairings, photo strip ---------- */
  function addToCart(ids, btn, done){
    if (btn) btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var body = { items: ids.map(function(id){ return { id: id, quantity: 1 }; }) };
    if (drawer && drawer.renderContents){ body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
      .then(function(res){
        if (btn) btn.disabled = false;
        if (done) done(res.ok, res.j);
        if (!res.ok) return;
        if (drawer && drawer.renderContents && res.j.sections){
          var first = (res.j.items && res.j.items[0]) || res.j;
          try { drawer.classList.remove('is-empty'); drawer.renderContents(Object.assign({}, first, { sections: res.j.sections })); } catch(e){ window.location.href = '/cart'; }
        } else { window.location.href = '/cart'; }
      })
      .catch(function(){ if (btn) btn.disabled = false; if (done) done(false); });
  }
  var PAIRS = [
    ['mad mango', 'mad-mango-heat-6-6-oz-shaker', 'Mad Mango Heat'],
    ['honey chipotle', 'honey-chipotle-charm', 'Honey Chipotle Charm'],
    ['sassy sriracha', 'sassy-sriracha-maple-4-8-oz-shaker', 'Sassy Sriracha Maple'],
    ['daily drip', 'daily-drip', 'Daily Drip']
  ];
  var COLOR_WORDS = ['Black','White','Lavender','Blue','Gold','Yellow','Red','Pink','Tan'];
  function typeOf(t){ t = t.toLowerCase(); if (/hoodie/.test(t)) return 'Hoodies'; if (/long[- ]sleeve/.test(t)) return 'Long sleeve'; if (/crop/.test(t)) return 'Crop'; return 'Tees'; }
  function apparel(){
    if (!document.documentElement.classList.contains('ps-apparel')) return;
    var grid = document.querySelector('ul.product-grid'); if (!grid) return;
    var lis = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid__item'));
    if (!lis.length) return;
    var items = lis.map(function(li){
      var a = li.querySelector('a[href*="/products/"]');
      var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      return { li: li, handle: m ? m[1] : null };
    }).filter(function(x){ return x.handle; });
    Promise.all(items.map(function(it){
      return fetch('/products/' + it.handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    })).then(function(prods){
      var types = {}, colors = {}, strip = [];
      prods.forEach(function(p, i){
        var it = items[i], li = it.li; if (!p) return;
        var type = typeOf(p.title); types[type] = 1;
        var cset = {};
        var ci = p.options.map(function(o){ return (o.name || o).toString().toLowerCase(); }).indexOf('color');
        if (ci > -1) (p.options[ci].values || []).forEach(function(v){ COLOR_WORDS.forEach(function(w){ if (v.toLowerCase().indexOf(w.toLowerCase()) > -1) cset[w] = 1; }); });
        COLOR_WORDS.forEach(function(w){ if (new RegExp('\\b' + w + '\\b', 'i').test(p.title)) cset[w] = 1; });
        Object.keys(cset).forEach(function(c){ colors[c] = 1; });
        li.dataset.psType = type; li.dataset.psColors = Object.keys(cset).join(',');
        if (p.featured_image && strip.length < 12) strip.push({ img: p.featured_image, url: p.url, title: p.title });

        var media = li.querySelector('.card__inner') || li;
        var created = Date.parse(p.created_at || p.published_at || '');
        if (created && (Date.now() - created) < 30 * 864e5 && !li.querySelector('.ps-new')){
          if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
          media.appendChild(el('span', 'ps-new', 'New drop'));
        }

        var anchor = li.querySelector('.card__content a.button') || li.querySelector('.price');
        if (!anchor || li.querySelector('.ps-sizes')) return;
        var si = p.options.map(function(o){ return (o.name || o).toString().toLowerCase(); }).indexOf('size');
        var box = el('div', 'ps-sizes');
        var colorCount = ci > -1 ? (p.options[ci].values || []).length : 1;
        if (si > -1 && colorCount <= 1){
          box.appendChild(el('div', 'ps-sizes__label', 'Tap a size to add'));
          var row = el('div', 'ps-sizes__row');
          (p.options[si].values || []).forEach(function(size){
            var v = p.variants.filter(function(x){ return x.options[si] === size && x.available; })[0];
            var b = el('button', 'ps-size', esc(size)); b.type = 'button';
            if (!v){ b.disabled = true; b.title = 'Sold out'; }
            else b.addEventListener('click', function(ev){
              ev.preventDefault(); ev.stopPropagation();
              b.classList.add('is-busy');
              addToCart([v.id], b, function(ok){ b.classList.remove('is-busy'); if (ok){ b.classList.add('is-added'); setTimeout(function(){ b.classList.remove('is-added'); }, 1600); } });
            });
            row.appendChild(b);
          });
          box.appendChild(row);
          /* real low stock only: variants that stop selling at 0 and have 5 or fewer left */
          var LOW = window.PS_LOW || {}, lows = [];
          p.variants.forEach(function(x){ var q = LOW[x.id]; if (q > 0) lows.push({ s: x.options[si], q: q }); });
          if (lows.length){
            lows.sort(function(a, b){ return a.q - b.q; });
            var txt = 'Only ' + lows[0].q + ' left in ' + esc(lows[0].s) + (lows[1] ? ' &middot; ' + lows[1].q + ' in ' + esc(lows[1].s) : '');
            box.appendChild(el('div', 'ps-low', '&#128293; ' + txt));
          }
        } else if (si > -1){
          box.appendChild(el('a', 'ps-sizes__pick', 'Pick color &amp; size &rarr;')).href = p.url;
        }
        var t = p.title.toLowerCase();
        var pair = PAIRS.filter(function(x){ return t.indexOf(x[0]) > -1; })[0];
        if (pair){
          var pr = el('div', 'ps-pair', '<span class="ps-pair__txt">&#127798;&#65039; Pairs with <a href="/products/' + pair[1] + '">' + esc(pair[2]) + '</a></span><button type="button" class="ps-pair__add">+ Add shaker</button>');
          pr.querySelector('button').addEventListener('click', function(ev){
            var btn = ev.currentTarget; ev.preventDefault();
            fetch('/products/' + pair[1] + '.js').then(function(r){ return r.json(); }).then(function(sp){
              var sv = sp.variants.filter(function(x){ return x.available; })[0];
              if (!sv){ btn.textContent = 'Sold out'; btn.disabled = true; return; }
              addToCart([sv.id], btn, function(ok){ if (ok){ btn.textContent = 'Added ✓'; setTimeout(function(){ btn.textContent = '+ Add shaker'; }, 1800); } });
            });
          });
          box.appendChild(pr);
        }
        anchor.parentNode.insertBefore(box, anchor);
      });

      /* filter chips */
      var host = grid.closest('.product-grid-container') || grid.parentNode;
      if (!document.querySelector('.ps-chips')){
        var order = ['Tees','Long sleeve','Crop','Hoodies'];
        var bar = el('div', 'ps-chips');
        var html = '<button type="button" class="ps-chip is-on" data-f="all">All</button>';
        order.forEach(function(k){ if (types[k]) html += '<button type="button" class="ps-chip" data-f="type:' + k + '">' + k + '</button>'; });
        var cl = Object.keys(colors);
        if (cl.length > 1){ html += '<span class="ps-chips__sep" aria-hidden="true"></span>'; COLOR_WORDS.forEach(function(c){ if (colors[c]) html += '<button type="button" class="ps-chip ps-chip--color" data-f="color:' + c + '"><i style="--c:' + c.toLowerCase() + '"></i>' + c + '</button>'; }); }
        bar.innerHTML = html;
        host.parentNode.insertBefore(bar, host);
        bar.addEventListener('click', function(ev){
          var b = ev.target.closest('.ps-chip'); if (!b) return;
          bar.querySelectorAll('.ps-chip').forEach(function(x){ x.classList.toggle('is-on', x === b); });
          var f = b.getAttribute('data-f');
          grid.classList.toggle('ps-filtered', f !== 'all');
          lis.forEach(function(li){
            var show = true;
            if (f.indexOf('type:') === 0) show = li.dataset.psType === f.slice(5);
            if (f.indexOf('color:') === 0) show = (li.dataset.psColors || '').split(',').indexOf(f.slice(6)) > -1;
            li.classList.toggle('ps-hide', !show);
          });
        });
      }

      /* scrolling photo strip after the 2nd row */
      if (strip.length > 3 && !grid.querySelector('.ps-strip') && lis.length > 8){
        var s = el('li', 'grid__item ps-strip');
        var imgs = strip.map(function(x, i){ return '<a href="' + esc(x.url) + '" tabindex="-1"><img loading="lazy" src="' + esc(x.img + (x.img.indexOf('?') > -1 ? '&' : '?') + 'width=360') + '" alt=""></a>' + (i % 3 === 2 ? '<span class="ps-strip__word">Wear the flavor</span>' : ''); }).join('');
        s.innerHTML = '<div class="ps-strip__track" aria-hidden="true"><div class="ps-strip__set">' + imgs + '</div><div class="ps-strip__set">' + imgs + '</div></div>';
        lis[7].after(s);
      }
    });
  }

  /* Over 50 products: Shopify's page data only lists the first 50, so pull the full
     rating/heat list from /collections/all?view=ps-meta (cached 10 min per visit). */
  function loadFull(){
    var KEY = 'ps_meta_v1', c = null;
    try { c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch(e){}
    function apply(m){
      D.heat = Object.assign({}, D.heat, m.heat); D.stars = Object.assign({}, D.stars, m.stars);
      D.full = true; heatPills();
    }
    if (c && Date.now() - c.t < 600000){ apply(c); return; }
    var acc = { heat: {}, stars: {} };
    (function get(page){
      fetch('/collections/all?view=ps-meta&page=' + page, { credentials: 'same-origin' })
        .then(function(r){ return r.json(); })
        .then(function(j){
          Object.assign(acc.heat, j.heat || {}); Object.assign(acc.stars, j.stars || {});
          if (j.next && page < 20) return get(j.next);
          acc.t = Date.now(); try { sessionStorage.setItem(KEY, JSON.stringify(acc)); } catch(e){}
          apply(acc);
        })
        .catch(function(){ D.full = true; heatPills(); });
    })(1);
  }
  window.PS_SHOP_loadFull = loadFull;

  ready(function(){
    heatPills();
    if (D.more) loadFull();
    if (isProduct) pdp();
    recentlyViewed();
    apparel();
    if ('MutationObserver' in window){
      var t; new MutationObserver(function(){ clearTimeout(t); t = setTimeout(function(){ heatPills(); }, 150); }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    }
  });
})();
